import { type FC, useState } from 'react';

import Button from '@/components/DesignLibrary/Button';
import HtmlContent from '@/components/HtmlContent';
import Modal from '@/components/Modal';
import Spacer from '@/components/Spacer';

import s from './ConfirmationModal.module.scss';

type Props = {
  onClose: () => void;
  text: string;
  onSubmit: () => unknown;
  cta: string;
  variant?: Parameters<typeof Button>[0]['variant'];
};

const ConfirmationModal: FC<Props> = ({ onClose, text, onSubmit, cta, variant = 'primary' }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick = (): void => {
    setIsSubmitting(true);
    onSubmit();
  };

  return (
    <Modal title='Confirm' onClose={onClose}>
      <div className={s.container}>
        <HtmlContent className='body-sm' content={text.replace(/\n/g, '<br />')} />
        <Spacer size='16px' />
        <Button size='md' fullWidth variant={variant} loading={isSubmitting} onClick={handleClick}>
          {cta}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
